import { React, useEffect, useState } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
} from "../../styledElements";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Button, PageHeader, Table, Tooltip } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import moment from "moment";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import {
  getAllUsers,
  getFilteredUsers,
  getSearchedUsers,
} from "../../../Services/loginServices";
import { Styled } from "../../pageStyled";
import DefaultProfilePicture from "../../../Assets/Images/default-pic.png";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { getImageURL } from "../../../Services/deckleMatchServices";

function onChange(pagination, filters, sorter, extra) {
  // setAllUsers([]);
  // console.log("params", pagination, filters, sorter, extra);
}

const UserManagementData = (props) => {
  const location = useLocation();
  const [allUsers, setAllUsers] = useState([]);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const history = useNavigate();
  const [loading, setLoading] = useState(true);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [rendering, setRendering] = useState(false);
  const [editUserToaster, setEditUserToaster] = useState(location?.state?.response ? true : false);
  const formatFilters = (item) => {
    switch (item.type) {
      case "role":
        const roleValue = item.role === "BOTH" ? "BASIC/ADMIN" : item.role;
        return {
          type: item.type,
          formattedType: "Role",
          operand: "-",
          value: roleValue,
        };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
    }
  };

  const removeFilter = (filter) => {
    setAllUsers([]);
    const filterList = appliedFilters.filter((item) => {
      return item.type !== filter.type;
    });
    const formattedFilterList = filterTags.filter((item) => {
      return item.type !== filter.type;
    });
    setFilterTags(formattedFilterList);
    setAppliedFilters(filterList);
    setRendering(true);
  };

  const refresh  = () => {
    setLoading(true);
    fetchAllUsers();
    setSearchValue("");
    setClearSearch(true);
    setRendering(true);
  }

  const navigate = useNavigate();

  const columnsHead = [
    {
      title: "User",
      dataIndex: "name",
      sorter: {
        compare: (a, b) => a.name && b.name && a.name.localeCompare(b.name),
        multiple: 3,
      },
      render: (text, record) => (
        <div className="userDataCell">
          <div className="userPimage">
            <img
              src={record.profile_picture?`${record.profile_picture}`:DefaultProfilePicture}
              alt={record.name}
            />
          </div>
          <div className="userBio">
            <label>
              {record.name}{" "}
              {/* {record.role_type == "ADMIN" ? ( */}
                <span style={{ textTransform: "capitalize" }}>
                  {record.role_type.replaceAll("_"," ")}
                </span>
              {/* ) : (
                ""
              )}{" "} */}
            </label>
            <p>{record.email}</p>
          </div>
        </div>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      sorter: {
        compare: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      },
      render: (text, record) => (
        <>{moment(record.created_at).format("DD MMM YYYY")}</>
      ),
    },
    {
      title: "Last Activity",
      dataIndex: "last_activity",
      sorter: {
        compare: (a, b) =>
          moment(a.last_activity).fromNow() - moment(b.last_activity).fromNow(),
      },
      render: (text, record) => (
        <>
          {record.last_activity
            ? moment(record.last_activity).fromNow()
            : "New User"}
        </>
      ),
    },
    {
      title: "Access",
      dataIndex: "access_count",
      width: "16%",
      render: (text, record) => (
        <p>Has access to {record.access_count} modules</p>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      align: "center",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.role_type === "Super Admin" ||
                (record.role_type === "ADMIN") |
                  !userDetails.roles.user_management.edit ||
                userDetails.email === record.email
                  ? null
                  : "Edit this user"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
                <Button
                  disabled={
                    record.role_type === "Super Admin" ||
                    (record.role_type === "ADMIN") |
                      !userDetails.roles.user_management.edit ||
                    userDetails.email === record.email
                  }
                >
                  <Link
                to={{
                  pathname: "/organization-setting/user-management/edit-user",
                  search: `?email=${record.email}`,
                  state: { email: record.email },
                }}
              >
                  <Iconmoon icon="edit" size={16} color="#A19F9D" />
                  </Link>
                </Button>
            </Tooltip>
          </Styled>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                !userDetails.roles.user_management.view ||
                record.role_type === "Super Admin"
                  ? null
                  : "View details of this user"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              
                <Button
                  disabled={
                    !userDetails.roles.user_management.view ||
                    record.role_type === "Super Admin"
                  }
                >
                  <Link
                to={{
                  pathname:
                    "/organization-setting/user-management/user-profile",
                  search: `?email=${record.email}`,
                  state: { email: record.email },
                }}
              >
                  <Iconmoon icon="file-view" size={16} color="#A19F9D" />
                  </Link>
                </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
    },
  ];

  const fetchAllUsers = async () => {
  try {
    const getUsers = await getAllUsers();

    if (!getUsers.length) {
      setEmptyStateLabel("noData");
      setLoading(false);
      return;
    }

    const updatedUsers = await Promise.all(
      getUsers.map(async (user) => {
        const res = user.profile_picture && await getImageURL({
          bucket_key: user.profile_picture,
          operation: "download",
        });
        return {
          ...user,
          profile_picture: res,
        };
      })
    );

    setAllUsers(updatedUsers);
    setLoading(false);
  } catch (error) {
    setLoading(false);
    console.log(error);
    setEmptyStateLabel("connectionAPIError");
  }
};


  const inviteUserHandler = () => {
    // console.log("Inside invite handler");
    navigate("/organization-setting/user-management/invite-user", {
      replace: true,
    });
  };

  useEffect(() => {
    if(rendering){
      fetchAllUsers();
      setRendering(false);    
    } else{
      fetchAllUsers();
    }
  }, [rendering]);

  useEffect(() => {
    if (appliedFilters.length) {
      fetchFilteredUsers();
    } else if (!clearSearch) {
  getSearchedUsers(searchValue).then(async (response) => {
    const updatedUsers = await Promise.all(
      response.map(async (user) => {
        const url = user.profile_picture && await getImageURL({
          bucket_key: user.profile_picture,
          operation: "download",
        });
        return {
          ...user,
          profile_picture: url,
        };
      })
    );

    setAllUsers(updatedUsers);
  });
}
else {
      fetchAllUsers();
    }
  }, [appliedFilters]);

  useEffect(() => {
    let propsData = {};
    if(emptyStateLabel === "noData"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] = "There are no records to show in this list. Add your first record to view details here";
    } else if(emptyStateLabel === "search"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if(emptyStateLabel === "filter"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] = "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  },[emptyStateLabel]);

const fetchFilteredUsers = () => {
  getFilteredUsers(appliedFilters)
    .then(async (response) => {
      setEmptyStateLabel("filter");

      const updatedUsers = await Promise.all(
        response.data.map(async (user) => {
          const url = user.profile_picture && await getImageURL({
            bucket_key: user.profile_picture,
            operation: "download",
          });
          return {
            ...user,
            profile_picture: url,
          };
        })
      );

      setAllUsers(updatedUsers);
    })
    .catch((error) => {
      console.log(error);
      setEmptyStateLabel("connectionAPIError");
    });
};


  const applyfilter = (filter) => {
    setAllUsers([]);
    let temp = appliedFilters;
    let alreadySetFilter = false;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setFilterTags(tempVar.map(formatFilters));
  };

  const searchUser = async (value = "") => {
    setAllUsers([]);
    setSearchValue(value);
    if (value === "" || value === null) {
      fetchAllUsers();
    } else {
      setClearSearch(false);
      getSearchedUsers(value)
        .then((response) => {
          if (response.length) {
            const updatedUsers = response.map((user) => {
              const url = user.profile_picture && getImageURL({
                bucket_key: user.profile_picture,
                operation: "download",
              });
              return {
                ...user,
                profile_picture: url,
              };
            });
            setAllUsers(updatedUsers);
          } else {
            setEmptyStateLabel("search");
          }
        })
        .catch((error) => {
          console.log("Error in searching users:", error);
          setEmptyStateLabel("connectionAPIError");
        });
    }
  };
  
  const exportHandler = () => {
      const currentDate = new Date();
      const today = (currentDate.getDate() + "/" + currentDate.toLocaleString("default", { month: "long" }) + "/" +  currentDate.getFullYear());
      let fileName = "User_records_Kiaznn_"+today;
      if(appliedFilters?.length){
        history("/organization-setting/user-management/export-user", {
          state: {
            body: {
              appliedFilters: appliedFilters,
              page: "user records",
              type: "Filter"
            },
            rootPage: "/organization-setting/user-management",
            fileName: fileName,
          },
        });
      } else if(!clearSearch && searchValue) {
        history("/organization-setting/user-management/export-user", {
          state: {
            body: {
              searchValue: searchValue,
              page: "user records",
              type: "Search"
            },
            rootPage: "/organization-setting/user-management",
            fileName: fileName,
          },
        });
      } else{
        history("/organization-setting/user-management/export-user", {
          state: {
            body: {
              page: "user records",
              type: "All Data"
            },
            rootPage: "/organization-setting/user-management",
            fileName: fileName,
          },
        });
      }
  };
  return (
    <RightLayoutContainer>
      <PageTitleComp>
        <PageHeader
          ghost={false}
          title="User Management"
          extra={[
            <Button
              key="1"
              className="themeBtn"
              onClick={inviteUserHandler}
              disabled={!userDetails.roles.user_management.edit}
            >
              <Iconmoon icon="add-user" size={14} color="#ffffff" />
              Invite user
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <TableLayoutData>
        <div className="tableDataFormat">
          <SearchContainer
            placeholder={"Search user name"}
            exportRole={allUsers?.length ? true : false}
            exportTrigger={exportHandler}
            fetchOrder={searchUser}
            filterOptions={[
              {
                key: 0,
                label: "Filter by Role",
                value: "role",
                type: "multiSelect",
              },
              {
                key: 1,
                label: "Filter by Created date",
                value: "created_date",
                type: "date",
              },
            ]}
            applyFilter={applyfilter}
          />
          {filterTags.map((filter) => (
            <span className="filter-tags">
              <Iconmoon icon="filter" size={13} color="#a8a8a8" />
              &nbsp;
              <span>{filter.formattedType}</span>
              &nbsp;
              <span>{filter.operand}</span>
              &nbsp;
              <span>{filter.value}</span>
              <span>
                {" "}
                <button
                  onClick={() => {
                    removeFilter(filter);
                  }}
                >
                  {" "}
                  <Iconmoon icon="wrong" size={15} color="#a8a8a8" />{" "}
                </button>
              </span>
            </span>
          ))}
           {loading ? (
                    <TableShimmer
                      header = {columnsHead}
                      scroll = {1000}
                    />
                  ) : allUsers?.length ? (
          <Table
            columns={columnsHead}
            dataSource={allUsers}
            onChange={onChange}
            pagination={{
              total: allUsers.length,
              showTitle: false,
              showTotal: (total, range) =>
                `Showing ${range[0]}-${range[1]} of ${total} results`,
            }}
          />
          ) : (
            <EmptyState
              img= {emptyStateLabel === "noData" || emptyStateLabel === "filter" ? emptyState_NoData : 
              emptyStateLabel === "search" ? emptyState_Search : 
              emptyState_ConnectionAPIError}
              heading= {emptyStatePropsData.heading}
              subHeading= {emptyStatePropsData.subHeading}
              label={emptyStatePropsData.label}
              refresh={refresh}
              />
          )}
        </div>
      </TableLayoutData>

      {editUserToaster && (
        <AlertContainer
          // closeIcon={true}
          // setClose={setEditUserToaster}
          color={`${location.state.response.error ? "red" : "green"} toaster`}
          icon={location.state.response.error ? alertRed : alertGreen}
          msg={
            location?.state?.response?.msg ? location?.state?.response?.msg : `User updated successfully`
          }
        >
          {setTimeout(() => {
            setEditUserToaster(false);
            window.history.replaceState({}, document.title);
            }, 2000)}
        </AlertContainer>
      )}
    </RightLayoutContainer>
  );
};

export default UserManagementData;
